import { useUserPermissions } from "@repo/core/hooks/useUserPermissions";
import { WithPermissionProps } from "./types";
import { Navigate } from "react-router-dom";
import { ROUTES } from "@repo/core/routes";

export const WithPermission = ({
  permissions = [],
  routeRedirect = ROUTES.home,
  children
}: WithPermissionProps) => {
  const { hasPermission } = useUserPermissions();

  if (permissions?.length && !hasPermission(permissions)) {
    return <Navigate to={routeRedirect} replace />;
  }
  return children;
};
